module.exports = __webpack_public_path__ + "static/media/16.88362e85.jpeg";